/**
 * Time Options
 *
 * Shared time options for use across Settings and Onboarding components.
 * Generates 30-minute increment options with 12-hour AM/PM display format.
 *
 * Used by:
 * - QuietHoursSection (quiet hours time selectors)
 * - NotificationsStep (digest delivery time)
 * - DeliveryPreferencesCard (scheduled notification times)
 */

export interface TimeOption {
  label: string;
  value: string;
}

/**
 * Generate time options in 30-minute increments
 * @returns Array of time options with 12-hour AM/PM labels and 24-hour values
 */
function generateTimeOptions(): TimeOption[] {
  const options: TimeOption[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (const minute of [0, 30]) {
      const hourStr = hour.toString().padStart(2, '0');
      const minStr = minute.toString().padStart(2, '0');
      const value = `${hourStr}:${minStr}`;

      // Format for display (12-hour with AM/PM)
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const ampm = hour < 12 ? 'AM' : 'PM';
      const label = `${displayHour}:${minStr} ${ampm}`;

      options.push({ label, value });
    }
  }
  return options;
}

export const TIME_OPTIONS = generateTimeOptions();
